import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <small class="created-by text-muted"><b><a href="" target="_blank" class="text-warning"> Loga Internet ©</a></b> 2023</small>
  `,
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/@theme/components/footer/footer.component.ts